import React, { Component } from "react";
import ReactDOM from "react-dom";
import axios from "axios";

class ThankYou extends Component {
    constructor(props) {
        super(props);
        this.state = {
            billingPlan: null,
            person: null,
            responseData: null,
            errorMessage: null,
        };
    }

    getPlanData() {
        axios.get("/api/persons").then((response) => {
            console.log(response.data);
            this.setState({ person: response.data }, function () {
                this.setState({ responseData: true });
            });
        });
    }
    componentDidMount() {
        const { hostedpage_id } = this.props;
        axios
            .post("/api/zoho/hosted-page/handle-success-subscriptions", {
                hostedpage_id,
            })
            .then((response) => {
                this.setState({
                    errorMessage: null,
                });
                return axios.get(
                    "/api/billing-plans/" + response.data.data.billing_plan_id
                );
                console.log("Success:", response.data);
            })
            .then((BillingPlanResponse) => {
                this.getPlanData();
            })
            .catch((error) => {
                this.setState({
                    errorMessage: error.response
                        ? error.response.data.message
                        : "An error occurred",
                });
                console.error("Error:", error);
            });
    }

    render() {
        const { responseData, errorMessage } = this.state;
        return (
            <>
                {errorMessage && (
                    <div className="error-message">
                        <p>Error: {errorMessage}</p>
                    </div>
                )}
                {responseData && (
                    <div
                        className="text-center align-self-end p-sm-16 p-10 bg-white rounded border border-gray"
                        style={{
                            boxShadow: "0px 1px 15px rgba(0, 0, 0, 0.12)",
                            width: "500px",
                        }}
                    >
                        <h1 className="thank-you-title">¡Gracias!</h1>
                        <p className="thank-you-subtitle">por tu compra</p>
                        <div className="divider"></div>
                        <div className="summary-item">
                            <div className="summary">
                                <span>
                                    Plan{" "}
                                    {
                                        this.state.person.subscription
                                            .billing_plan.name
                                    }{" "}
                                </span>
                                <p className="summary-description">
                                    <ul className="list-unstyled">
                                        {this.state.person.subscription.billing_plan.limitations.map(
                                            (limitation, index) => (
                                                <li
                                                    key={index}
                                                    className="text-muted"
                                                >
                                                    {
                                                        limitation.limitation_value
                                                    }{" "}
                                                    {limitation.limitation_label ===
                                                    "Almacenamiento"
                                                        ? "GB"
                                                        : ""}{" "}
                                                    {
                                                        limitation.limitation_label
                                                    }
                                                </li>
                                            )
                                        )}
                                    </ul>
                                </p>
                            </div>
                            <span className="price">
                                $ {this.state.person.subscription.billing_plan.price}
                            </span>
                        </div>

                        {this.state.person.subscription.discount_amount > 0 && (
                            <div className="summary-item">
                                <span>Descuento (Cupón: {this.state.person.subscription.coupon_code})</span>
                                <span className="price text-danger">
                                    - $ {this.state.person.subscription.discount_amount}
                                </span>
                            </div>
                        )}

                        <div className="divider"></div>

                        <div className="summary-item font-weight-bolder">
                            <span>Total</span>
                            <span className="price">
                                $ {this.state.person.subscription.amount}
                            </span>
                        </div>

                        <div className="divider"></div>
                        {this.state.person.credit_cards.length > 0 && (
                            <div className="summary-item">
                                <div>
                                    <span>Método de pago</span>
                                    <p className="summary-description">
                                        {
                                            this.state.person.credit_cards[0]
                                                .brand
                                        }{" "}
                                        ****
                                        {
                                            this.state.person.credit_cards[0]
                                                .last_four_digits
                                        }
                                    </p>
                                </div>
                            </div>
                        )}
                        <div className="text-center mt-4">
                            <a href="/" className="btn btn-start btn-sm">
                                Comenzar
                            </a>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

export default ThankYou;

if (document.getElementById("ThankYou")) {
    ReactDOM.render(<ThankYou />, document.getElementById("ThankYou"));
}
